import { GenderEnum } from "@/enums/mateEnums";
import api from "@/modules/api";

export const buildRedrawParams = (params: {
  gender?: GenderEnum;
  referenceMediaId?: number;
}): Parameters<typeof api.createOneTextImageTask>[0] => {
  const { gender, referenceMediaId } = params;
  const prompt = gender === GenderEnum.MALE ? "1boy," : "1girl,";
  const res: Parameters<typeof api.createOneTextImageTask>[0] = {
    ratio: "3:4",
    amount: 1,
    from: "trait",
    // customStyle: { version: 1, prompt: "" },
    style: 1,
  };
  if (referenceMediaId) {
    res.env = { mediaId: referenceMediaId };
  } else {
    res.prompt = prompt;
  }
  return res;
};
